import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as StarIcon } from "images/star-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";
import showcase1 from "images/showcase/bedroom-1.jpg";
import showcase2 from "images/showcase/bedroom-2.jpg";
import showcase3 from "images/showcase/kitchen-1.jpg";
import showcase4 from "images/showcase/kitchen-2.jpg";
import showcase5 from "images/showcase/living-room-1.jpg";
import showcase6 from "images/showcase/living-room-2.jpg";
import showcase7 from "images/showcase/restroom-1.jpg";
import showcase8 from "images/showcase/restroom-2.jpg";
import showcase9 from "images/showcase/entrance-1.jpg";
import showcase10 from "images/showcase/entrance-2.jpg";

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;
const TabsControl = tw.div`flex flex-wrap bg-gray-200 px-2 py-2 rounded leading-none mt-12 xl:mt-0`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
  &:hover {
    ${tw`bg-gray-300 text-gray-700`}
  }
  ${props => props.active && tw`bg-primary-500! text-gray-100!`}
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;
const Card = tw(motion.a)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;
const CardRatingContainer = tw.div`leading-none absolute inline-flex bg-gray-100 bottom-0 left-0 ml-4 mb-4 rounded-full px-5 py-2 items-end`;
const CardRating = styled.div`
  ${tw`mr-1 text-sm font-bold flex items-end`}
  svg {
    ${tw`w-4 h-4 fill-current text-orange-400 mr-1`}
  }
`;

const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.5);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`text-sm`;

const CardReview = tw.div`font-medium text-xs text-gray-600`;

const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-primary-500`;
const CardContent = tw.p`mt-1 text-sm font-medium text-gray-600`;
const CardPrice = tw.p`mt-4 text-xl font-bold`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

export default ({
  heading = "工程設計作品",
  tabs = {
    "全部": [
      {
        imageSrc: showcase1,
        title: "現代簡約臥室",
        content: "內置衣櫃設計",
        price: "NT$180,000",
        rating: "4.9",
        reviews: "32",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase2,
        title: "雙層床設計",
        content: "空間最佳化設計",
        price: "NT$220,000",
        rating: "4.8",
        reviews: "28",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },{
        imageSrc: showcase3,
        title: "現代廚房",
        content: "一字型廚房設計",
        price: "NT$320,000",
        rating: "4.9",
        reviews: "45",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase4,
        title: "小型廚房",
        content: "多功能廚房設計",
        price: "NT$280,000",
        rating: "4.7",
        reviews: "36",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase5,
        title: "現代客廳",
        content: "電視櫃組合設計",
        price: "NT$250,000",
        rating: "5.0",
        reviews: "42",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase6,
        title: "簡約客廳",
        content: "收納櫃設計",
        price: "NT$230,000",
        rating: "4.8",
        reviews: "38",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase7,
        title: "現代浴室",
        content: "乾濕分離設計",
        price: "NT$200,000",
        rating: "4.9",
        reviews: "29",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase8,
        title: "簡約衛浴",
        content: "完整衛浴設計",
        price: "NT$180,000",
        rating: "4.8",
        reviews: "25",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase9,
        title: "現代玄關",
        content: "鞋櫃收納設計",
        price: "NT$150,000",
        rating: "4.7",
        reviews: "23",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase10,
        title: "簡約玄關",
        content: "壁掛收納設計",
        price: "NT$130,000",
        rating: "4.8",
        reviews: "21",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      }
    ],
    "臥室設計": [
      {
        imageSrc: showcase1,
        title: "現代簡約臥室",
        content: "內置衣櫃設計",
        price: "NT$180,000",
        rating: "4.9",
        reviews: "32",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase2,
        title: "雙層床設計",
        content: "空間最佳化設計",
        price: "NT$220,000",
        rating: "4.8",
        reviews: "28",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      }
    ],
    "廚房設計": [
      {
        imageSrc: showcase3,
        title: "現代廚房",
        content: "一字型廚房設計",
        price: "NT$320,000",
        rating: "4.9",
        reviews: "45",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase4,
        title: "小型廚房",
        content: "多功能廚房設計",
        price: "NT$280,000",
        rating: "4.7",
        reviews: "36",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      }
    ],
    "客廳設計": [
      {
        imageSrc: showcase5,
        title: "現代客廳",
        content: "電視櫃組合設計",
        price: "NT$250,000",
        rating: "5.0",
        reviews: "42",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase6,
        title: "簡約客廳",
        content: "收納櫃設計",
        price: "NT$230,000",
        rating: "4.8",
        reviews: "38",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      }
    ],
    "衛浴空間": [
      {
        imageSrc: showcase7,
        title: "現代浴室",
        content: "乾濕分離設計",
        price: "NT$200,000",
        rating: "4.9",
        reviews: "29",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase8,
        title: "簡約衛浴",
        content: "完整衛浴設計",
        price: "NT$180,000",
        rating: "4.8",
        reviews: "25",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      }
    ],
    "玄關設計": [
      {
        imageSrc: showcase9,
        title: "現代玄關",
        content: "鞋櫃收納設計",
        price: "NT$150,000",
        rating: "4.7",
        reviews: "23",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      },
      {
        imageSrc: showcase10,
        title: "簡約玄關",
        content: "壁掛收納設計",
        price: "NT$130,000",
        rating: "4.8",
        reviews: "21",
        url: "https://www.facebook.com/profile.php?id=100063981819514"
      }
    ]
  }
}) => {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
   */
  const tabsKeys = Object.keys(tabs);
  const [activeTab, setActiveTab] = useState(tabsKeys[0]);

  return (
    <Container id="showcase">
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header>{heading}</Header>
          <TabsControl>
            {Object.keys(tabs).map((tabName, index) => (
              <TabControl key={index} active={activeTab === tabName} onClick={() => setActiveTab(tabName)}>
                {tabName}
              </TabControl>
            ))}
          </TabsControl>
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: {
                opacity: 1,
                scale:1,
                display: "flex",
              },
              hidden: {
                opacity: 0,
                scale:0.8,
                display: "none",
              }
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            {tabs[tabKey].map((card, index) => (
              <CardContainer key={index}>
                <Card className="group" target="_blank" href={card.url} initial="rest" whileHover="hover" animate="rest">
                  <CardImageContainer imageSrc={card.imageSrc}>
                    {/* <CardRatingContainer>
                      <CardRating>
                        <StarIcon />
                        {card.rating}
                      </CardRating>
                      <CardReview>({card.reviews})</CardReview>
                    </CardRatingContainer> */}
                    <CardHoverOverlay
                      variants={{
                        hover: {
                          opacity: 1,
                          height: "auto"
                        },
                        rest: {
                          opacity: 0,
                          height: 0
                        }
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <CardButton>Facebook觀看</CardButton>
                    </CardHoverOverlay>
                  </CardImageContainer>
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                    {/* <CardPrice>{card.price}</CardPrice> */}
                  </CardText>
                </Card>
              </CardContainer>
            ))}
          </TabContent>
        ))}
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
/* 修改示例數據生成函數 */
const getRandomCards = () => {
  const cards = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      title: "現代風格設計",
      content: "居家空間規劃",
      price: "NT$580,000",
      rating: "4.9",
      reviews: "43",
      url: "#"
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      title: "工業風設計",
      content: "商業空間規劃",
      price: "NT$780,000",
      rating: "4.8",
      reviews: "34",
      url: "#"
    },
    // ... 可以繼續添加更多示例
  ];

  return cards.sort(() => Math.random() - 0.5);
};

